export const multilineData = [
  {
    id: 1,
    name: "Customer",
    role: "Selling",
  },
  {
    id: 2,
    name: "Producer",
    role: "sdf",
  },
  {
    id: 3,
    name: "Director",
    role: "wer",
  },
];
